export default __webpack_public_path__ + "1c43421f7ef763b5096fb7d8737599d3.png";